import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useServicesPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { useCompanyInfoPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { useScopePermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type CompanyModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const CompanyModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: CompanyModalProps): JSX.Element => {
  const companyInfoPermalink = useCompanyInfoPermalink()
  const servicesPermalink = useServicesPermalink()
  const scopePermalink = useScopePermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.COMPANY]: {
          ...context[ChatContextSourceType.COMPANY],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={companyInfoPermalink}>company info</ExternalLink>
        ,&nbsp;<ExternalLink to={servicesPermalink}>services</ExternalLink>
        &nbsp;and <ExternalLink to={scopePermalink}>scoping</ExternalLink>{' '}
        answers
      </p>
    ),
    [companyInfoPermalink, servicesPermalink, scopePermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Company Info"
      description={description}
      prompt="Do consider what we have marked in the company info, services and scoping sections"
      currentSelection={context[ChatContextSourceType.COMPANY].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
